import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

// Initialize PostHog (call once at app startup)
export const initPostHog = () => {
  if (!POSTHOG_KEY) {
    console.log('[PostHog] No API key configured, analytics disabled');
    return false;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: true,           // Auto-track clicks, form submissions
    capture_pageview: true,      // Auto-track page views
    capture_pageleave: true,     // Track when users leave pages
    persistence: 'localStorage',
    loaded: (ph) => {
      console.log('[PostHog] Initialized successfully');
      // Disable in development if needed
      if (process.env.NODE_ENV === 'development') {
        // Uncomment to disable in dev:
        // ph.opt_out_capturing();
      }
    },
  });

  return true;
};

// Identify a user (call after login)
export const identifyUser = (user) => {
  if (!POSTHOG_KEY || !user) return;

  posthog.identify(String(user.id), {
    email: user.email,
    name: user.full_name || user.username,
    username: user.username,
    role: user.role,
  });

  console.log('[PostHog] User identified:', user.username);
};

// Reset user identity (call after logout)
export const resetUser = () => {
  if (!POSTHOG_KEY) return;

  posthog.reset();
  console.log('[PostHog] User reset');
};

// Track a custom event
export const trackEvent = (eventName, properties = {}) => {
  if (!POSTHOG_KEY) return;

  posthog.capture(eventName, properties);
};

// Export the posthog instance for advanced usage
export { posthog };
